var dropdownSubItem = 'subItem_dropdownSubItem__qv53bn0';

export { dropdownSubItem };
//# sourceMappingURL=subItem.vanilla.mjs.map
